module.exports = __webpack_public_path__ + "LatoLatin-HeavyItalic.99c388391eaa67f4e1b8.eot";


//////////////////
// WEBPACK FOOTER
// /Users/davidkross/Project/TaiwaneseTutor/front-end/TaiwaneseTutor/src/assets/fonts/LatoLatin/fonts/LatoLatin-HeavyItalic.eot
// module id = ../../../../../src/assets/fonts/LatoLatin/fonts/LatoLatin-HeavyItalic.eot
// module chunks = styles